import React, {useEffect} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {Card, CardContent, Container} from "@mui/material";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	ArcElement,
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import Grid from "@mui/material/Grid";
import clsx from "clsx";
import ReportDrawer from "./drawer/ReportDrawer";
import {TicketGiornoStato} from "./section/callcenter/TicketGiornoStato";
import {TicketCategoriaAsl} from "./section/callcenter/TicketCategoriaAsl";
import {TicketStato} from "./section/callcenter/TicketStato";
import {TicketUser} from "./section/callcenter/TicketUser";
import {TicketGiorno} from "./section/callcenter/TicketGiorno";
import {TicketCategoria} from "./section/callcenter/TicketCategoria";
import {TicketAsl} from "./section/callcenter/TicketAsl";
import {TicketCategoriaGiorno} from "./section/callcenter/TicketCategoriaGiorno";
import {TicketAslGiorno} from "./section/callcenter/TicketAslGiorno";
import {QuaranteneGiornoStato} from "./section/covid/QuaranteneGiornoStato";
import {AndamentoPositivi} from "./section/covid/AndamentoPositivi";
import {VacciniGiornoStato} from "./section/vaccini/VacciniGiornoStato";
import {useSessionStorage} from "../../../utils/hooks/SessionStorageHook";
import TabellaRiassuntiva from "./section/resume/TabellaRiassuntiva";

ChartJS.register(
	CategoryScale,
	ArcElement,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
);

const Report = () => {
	const classes = BaseStyle();
	const [menuSelected, setMenuSelected] = useSessionStorage("menuReport", "Andamento positivi");
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
		<React.Fragment>
			<main className={classes.main}>
				<HideAppBar title={"Report e grafici"}/>
				<Container component={"section"} maxWidth={"xl"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<div>
										<ReportDrawer selected={menuSelected} setSelected={setMenuSelected}/>
									</div>
									
									<div className={classes.content}>
										{menuSelected === "Ticket giorno - stato" && <TicketGiornoStato/>}
										{menuSelected === "Ticket giorno" && <TicketGiorno/>}
										{menuSelected === "Ticket stato" && <TicketStato/>}
										{menuSelected === "Ticket categoria" && <TicketCategoria/>}
										{menuSelected === "Ticket ASL" && <TicketAsl/>}
										{menuSelected === "Ticket categoria - ASL" && <TicketCategoriaAsl/>}
										{menuSelected === "Ticket categoria - giorno" && <TicketCategoriaGiorno/>}
										{menuSelected === "Ticket ASL - giorno" && <TicketAslGiorno/>}
										{menuSelected === "Utente" && <TicketUser/>}
										
										{menuSelected === "Quarantene giorno - stato" && <QuaranteneGiornoStato/>}
										{menuSelected === "Andamento positivi" && <AndamentoPositivi/>}
										
										{menuSelected === "Vaccini giorno - tipo" && <VacciniGiornoStato/>}
										{menuSelected === "Tabella riassuntiva" && <TabellaRiassuntiva/>}
									</div>
								
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
		</React.Fragment>
	);
};

export default React.memo(Report);
